import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Nav from "../shared/Nav";
import Footer from "../shared/Footer";
import { fetchPublicTeam } from "../services/teamApi";
import "../assets/css/About.css";

const API_URL = process.env.REACT_APP_API_URL;

function getInitials(name = "") {
  return (
    name
      .split(" ")
      .map((n) => n[0])
      .join("")
      .toUpperCase()
      .slice(0, 2) || "?"
  );
}

function TeamSkeleton() {
  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
        gap: 28,
      }}
    >
      {[1, 2, 3].map((i) => (
        <div
          key={i}
          style={{
            borderRadius: 20,
            overflow: "hidden",
            background: "#f8fafc",
            border: "1px solid #e8edf4",
          }}
        >
          <div
            style={{
              height: 280,
              background: "linear-gradient(135deg, #e8edf4, #f0f4f8)",
            }}
          />
          <div style={{ padding: "20px 24px" }}>
            <div
              style={{
                height: 18,
                borderRadius: 8,
                background: "#e8edf4",
                marginBottom: 8,
                width: "60%",
              }}
            />
            <div
              style={{
                height: 14,
                borderRadius: 8,
                background: "#e8edf4",
                width: "40%",
              }}
            />
          </div>
        </div>
      ))}
    </div>
  );
}

const S = {
  page: {
    fontFamily: "'DM Sans', 'Segoe UI', sans-serif",
    color: "#0a1628",
    background: "#ffffff",
  },
  hero: {
    background:
      "linear-gradient(135deg, #0a1628 0%, #0e2a4a 50%, #0a3d62 100%)",
    padding: "100px 5% 80px",
    position: "relative",
    overflow: "hidden",
  },
  heroInner: {
    maxWidth: 900,
    margin: "0 auto",
    position: "relative",
    zIndex: 2,
  },
  heroBadge: {
    display: "inline-block",
    padding: "6px 18px",
    borderRadius: 100,
    background: "rgba(32,201,151,0.15)",
    border: "1px solid rgba(32,201,151,0.4)",
    color: "#20c997",
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: "0.14em",
    textTransform: "uppercase",
    marginBottom: 24,
  },
  heroHeading: {
    fontSize: "clamp(32px, 5vw, 58px)",
    fontWeight: 800,
    color: "#ffffff",
    lineHeight: 1.12,
    marginBottom: 20,
    fontFamily: "'Playfair Display', Georgia, serif",
    letterSpacing: "-0.02em",
  },
  heroSub: {
    fontSize: 17,
    color: "rgba(255,255,255,0.65)",
    lineHeight: 1.75,
    maxWidth: 640,
  },
  heroDeco1: {
    position: "absolute",
    top: -80,
    right: -80,
    width: 360,
    height: 360,
    borderRadius: "50%",
    background:
      "radial-gradient(circle, rgba(32,201,151,0.08) 0%, transparent 70%)",
    pointerEvents: "none",
  },
  heroDeco2: {
    position: "absolute",
    bottom: -60,
    left: "30%",
    width: 240,
    height: 240,
    borderRadius: "50%",
    background:
      "radial-gradient(circle, rgba(14,42,74,0.6) 0%, transparent 70%)",
    pointerEvents: "none",
  },
  label: {
    display: "inline-flex",
    alignItems: "center",
    gap: 7,
    padding: "5px 14px",
    borderRadius: 100,
    background: "rgba(10,54,98,0.07)",
    color: "#0a3d62",
    fontSize: 10,
    fontWeight: 800,
    letterSpacing: "0.14em",
    textTransform: "uppercase",
    marginBottom: 16,
  },
  labelDot: {
    width: 6,
    height: 6,
    borderRadius: "50%",
    background: "#20c997",
    flexShrink: 0,
  },
  storyGrid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: 64,
    alignItems: "center",
  },
  storyHeading: {
    fontSize: "clamp(26px, 3.5vw, 42px)",
    fontWeight: 800,
    color: "#0a1628",
    lineHeight: 1.2,
    marginBottom: 20,
    fontFamily: "'Playfair Display', Georgia, serif",
    letterSpacing: "-0.02em",
  },
  storyBody: {
    fontSize: 15,
    color: "#4a5568",
    lineHeight: 1.8,
    marginBottom: 16,
  },
  storyImg: {
    width: "100%",
    borderRadius: 20,
    objectFit: "cover",
    height: 380,
    boxShadow: "0 24px 60px rgba(10,22,40,0.18)",
  },
  statsStrip: {
    background: "linear-gradient(135deg, #0a1628, #0a3d62)",
    padding: "56px 5%",
  },
  statsInner: {
    maxWidth: 1200,
    margin: "0 auto",
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))",
    gap: 0,
  },
  statItem: {
    textAlign: "center",
    padding: "20px 24px",
    borderRight: "1px solid rgba(255,255,255,0.08)",
  },
  statVal: {
    fontSize: "clamp(30px,4vw,46px)",
    fontWeight: 900,
    color: "#ffffff",
    fontFamily: "'Playfair Display', Georgia, serif",
    lineHeight: 1,
    marginBottom: 8,
  },
  statLbl: {
    fontSize: 11,
    color: "rgba(255,255,255,0.55)",
    fontWeight: 600,
    textTransform: "uppercase",
    letterSpacing: "0.1em",
  },
  mvGrid: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 24 },
  mvCard: (accent) => ({
    borderRadius: 20,
    padding: "36px 32px",
    border: `1.5px solid ${accent}22`,
    background: `linear-gradient(135deg, ${accent}08, ${accent}03)`,
    position: "relative",
    overflow: "hidden",
  }),
  mvIcon: (accent) => ({
    width: 48,
    height: 48,
    borderRadius: 14,
    background: `${accent}15`,
    border: `1px solid ${accent}30`,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 22,
    marginBottom: 20,
  }),
  mvLabel: (accent) => ({
    fontSize: 10,
    fontWeight: 800,
    letterSpacing: "0.14em",
    textTransform: "uppercase",
    color: accent,
    marginBottom: 12,
  }),
  mvText: { fontSize: 15, color: "#4a5568", lineHeight: 1.8 },
  valuesSection: {
    padding: "80px 5%",
    background: "linear-gradient(180deg, #f8fafc 0%, #ffffff 100%)",
  },
  valuesInner: { maxWidth: 1200, margin: "0 auto" },
  valuesHeading: {
    fontSize: "clamp(26px,3.5vw,40px)",
    fontWeight: 800,
    color: "#0a1628",
    fontFamily: "'Playfair Display', Georgia, serif",
    marginBottom: 8,
  },
  valuesSub: {
    fontSize: 15,
    color: "#718096",
    marginBottom: 48,
    maxWidth: 520,
  },
  valuesGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))",
    gap: 24,
  },
  valueCard: {
    borderRadius: 20,
    padding: "32px 28px",
    background: "#ffffff",
    border: "1px solid #e8edf4",
    boxShadow: "0 2px 16px rgba(10,22,40,0.05)",
    transition: "transform 0.2s, box-shadow 0.2s, border-color 0.2s",
  },
  valueIcon: {
    width: 52,
    height: 52,
    borderRadius: 16,
    background: "linear-gradient(135deg, #e8f4fd, #d0f0e8)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 24,
    marginBottom: 18,
  },
  valueTitle: {
    fontSize: 16,
    fontWeight: 700,
    color: "#0a1628",
    marginBottom: 8,
  },
  valueDesc: { fontSize: 14, color: "#718096", lineHeight: 1.7 },
  cta: {
    background: "linear-gradient(135deg, #0a1628, #0a3d62)",
    padding: "80px 5%",
    textAlign: "center",
    position: "relative",
    overflow: "hidden",
  },
  ctaInner: {
    maxWidth: 700,
    margin: "0 auto",
    position: "relative",
    zIndex: 2,
  },
  ctaHeading: {
    fontSize: "clamp(26px,4vw,44px)",
    fontWeight: 800,
    color: "#ffffff",
    fontFamily: "'Playfair Display', Georgia, serif",
    marginBottom: 16,
    lineHeight: 1.2,
  },
  ctaSub: {
    fontSize: 16,
    color: "rgba(255,255,255,0.65)",
    marginBottom: 36,
    lineHeight: 1.7,
  },
  ctaBtns: {
    display: "flex",
    gap: 14,
    justifyContent: "center",
    flexWrap: "wrap",
  },
  btnPrimary: {
    padding: "14px 32px",
    borderRadius: 100,
    background: "#1B8FA6",
    border: "none",
    color: "#0a1628",
    fontSize: 14,
    fontWeight: 700,
    cursor: "pointer",
    letterSpacing: "0.02em",
    boxShadow: "0 6px 24px rgba(27, 143, 166, 0.35)",
    transition: "transform 0.2s, box-shadow 0.2s",
  },
  btnOutline: {
    padding: "14px 32px",
    borderRadius: 100,
    background: "transparent",
    border: "2px solid rgba(255,255,255,0.3)",
    color: "#ffffff",
    fontSize: 14,
    fontWeight: 600,
    cursor: "pointer",
    transition: "border-color 0.2s, background 0.2s",
  },
  headingGroup: { marginBottom: 48 },
  sectionHeading: {
    fontSize: "clamp(26px,3.5vw,40px)",
    fontWeight: 800,
    color: "#0a1628",
    fontFamily: "'Playfair Display', Georgia, serif",
    marginBottom: 8,
    lineHeight: 1.2,
  },
  divider: {
    width: 48,
    height: 3,
    background: "linear-gradient(90deg, #1B8FA6, #0a3d62)",
    borderRadius: 100,
    margin: "16px 0 0",
  },
};

export default function About() {
  const navigate = useNavigate();
  const [teamMembers, setTeamMembers] = useState([]);
  const [teamLoading, setTeamLoading] = useState(true);
  const [teamError, setTeamError] = useState(false);
  const [aboutData, setAboutData] = useState(null);
  const [hovered, setHovered] = useState(null);

  useEffect(() => {
    fetchPublicTeam()
      .then(setTeamMembers)
      .catch(() => setTeamError(true))
      .finally(() => setTeamLoading(false));
  }, []);

  useEffect(() => {
    fetch(`${API_URL}/api/about`)
      .then((r) => r.json())
      .then(({ data }) => {
        if (data) setAboutData(data);
      })
      .catch(() => {});
  }, []);

  const hero = aboutData?.hero;
  const story = aboutData?.story;
  const stats = aboutData?.stats || [];
  const values = aboutData?.values || [];
  const mission = aboutData?.mission;
  const vision = aboutData?.vision;
  const hasHero = hero?.badge || hero?.heading || hero?.subheading;
  const hasStory =
    story?.badge || story?.heading || story?.body1 || story?.body2;

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700;800;900&family=DM+Sans:wght@300;400;500;600;700&display=swap');
        .team-card-new { transition: transform 0.25s, box-shadow 0.25s; }
        .team-card-new:hover { transform: translateY(-6px); box-shadow: 0 20px 50px rgba(10,22,40,0.16) !important; }
        .team-card-new:hover .team-img-overlay { opacity: 1 !important; }
        .team-img-bw { filter: grayscale(100%); transition: filter 0.3s; }
        .team-card-new:hover .team-img-bw { filter: grayscale(0%); }
      `}</style>
      <Nav />
      <div style={S.page}>
        {/* ── HERO ── */}
        {hasHero && (
          <section style={S.hero}>
            <div style={S.heroDeco1} />
            <div style={S.heroDeco2} />
            <div style={S.heroInner}>
              {hero.badge && <div style={S.heroBadge}>{hero.badge}</div>}
              {hero.heading && <h1 style={S.heroHeading}>{hero.heading}</h1>}
              {hero.subheading && <p style={S.heroSub}>{hero.subheading}</p>}
            </div>
          </section>
        )}

        {/* ── STORY ── */}
        {hasStory && (
          <div style={{ padding: "80px 5%" }}>
            <div style={{ maxWidth: 1200, margin: "0 auto" }}>
              <div
                style={{
                  ...S.storyGrid,
                  gridTemplateColumns: story?.image ? "1fr 1fr" : "1fr",
                  maxWidth: 1100,
                  margin: "0 auto",
                  alignItems: "start",
                }}
              >
                <div>
                  {story.badge && (
                    <div style={S.label}>
                      <span style={S.labelDot} />
                      {story.badge}
                    </div>
                  )}
                  {story.heading && (
                    <h2 style={S.storyHeading}>{story.heading}</h2>
                  )}
                  <div style={S.divider} />
                  <div style={{ height: 24 }} />
                  {story.body1 && <p style={S.storyBody}>{story.body1}</p>}
                  {story.body2 && <p style={S.storyBody}>{story.body2}</p>}
                </div>
                {story.image && (
                  <div>
                    <img src={story.image} alt="Our Story" style={S.storyImg} />
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

        {/* ── STATS STRIP ── */}
        {stats.length > 0 && (
          <div style={S.statsStrip}>
            <div style={S.statsInner}>
              {stats.map((s, i) => (
                <div
                  key={i}
                  style={{
                    ...S.statItem,
                    borderRight:
                      i === stats.length - 1 ? "none" : S.statItem.borderRight,
                  }}
                >
                  <div style={S.statVal}>{s.value}</div>
                  <div style={S.statLbl}>{s.label}</div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* ── MISSION & VISION ── */}
        {(mission || vision) && (
          <div style={{ padding: "80px 5%", background: "#f8fafc" }}>
            <div style={{ maxWidth: 1200, margin: "0 auto" }}>
              <div style={S.headingGroup}>
                <div style={S.label}>
                  <span style={S.labelDot} />
                  Purpose
                </div>
                <h2 style={S.sectionHeading}>What We Stand For</h2>
                <div style={S.divider} />
              </div>
              <div
                style={{
                  ...S.mvGrid,
                  gridTemplateColumns: mission && vision ? "1fr 1fr" : "1fr",
                  maxWidth: mission && vision ? "100%" : 600,
                }}
              >
                {mission && (
                  <div style={S.mvCard("#0a3d62")}>
                    <div style={S.mvIcon("#0a3d62")}>🎯</div>
                    <div style={S.mvLabel("#0a3d62")}>Our Mission</div>
                    <p style={S.mvText}>{mission}</p>
                    <div
                      style={{
                        position: "absolute",
                        bottom: 0,
                        right: 0,
                        width: 100,
                        height: 100,
                        borderRadius: "50%",
                        background: "rgba(10,61,98,0.04)",
                        transform: "translate(30%, 30%)",
                        pointerEvents: "none",
                      }}
                    />
                  </div>
                )}
                {vision && (
                  <div style={S.mvCard("#20c997")}>
                    <div style={S.mvIcon("#20c997")}>🔭</div>
                    <div style={S.mvLabel("#20c997")}>Our Vision</div>
                    <p style={S.mvText}>{vision}</p>
                    <div
                      style={{
                        position: "absolute",
                        bottom: 0,
                        right: 0,
                        width: 100,
                        height: 100,
                        borderRadius: "50%",
                        background: "rgba(32,201,151,0.04)",
                        transform: "translate(30%, 30%)",
                        pointerEvents: "none",
                      }}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

        {/* ══ TEAM SECTION — updated to large photo cards ══ */}
        <div style={{ padding: "80px 5%", background: "#ffffff" }}>
          <div style={{ maxWidth: 1200, margin: "0 auto" }}>
            <div style={S.label}>
              <span style={S.labelDot} />
              Our People
            </div>
            <h2
              style={{
                fontSize: "clamp(26px,3.5vw,40px)",
                fontWeight: 800,
                color: "#0a1628",
                fontFamily: "'Playfair Display', Georgia, serif",
                marginBottom: 8,
              }}
            >
              Meet Our Team
            </h2>
            <div style={S.divider} />
            <div style={{ height: 48 }} />

            {teamLoading ? (
              <TeamSkeleton />
            ) : teamError ? (
              <p style={{ color: "#718096" }}>
                Unable to load team members right now.
              </p>
            ) : teamMembers.length === 0 ? (
              <p style={{ color: "#718096" }}>Team information coming soon.</p>
            ) : (
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
                  gap: 28,
                }}
              >
                {teamMembers.map((member, i) => (
                  <div
                    key={member._id}
                    className="team-card-new"
                    style={{
                      borderRadius: 20,
                      overflow: "hidden",
                      background: "#ffffff",
                      border: "1px solid #e8edf4",
                      boxShadow: "0 4px 20px rgba(10,22,40,0.07)",
                      cursor: "default",
                    }}
                  >
                    {/* Photo area */}
                    <div
                      style={{
                        position: "relative",
                        height: 300,
                        background: "linear-gradient(135deg, #e8edf4, #d0dce8)",
                        overflow: "hidden",
                      }}
                    >
                      {member.avatar ? (
                        <img
                          src={member.avatar}
                          alt={member.name}
                          className={i !== 0 ? "team-img-bw" : ""}
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            objectPosition: "top",
                            display: "block",
                          }}
                        />
                      ) : (
                        /* No photo — show large initials */
                        <div
                          style={{
                            width: "100%",
                            height: "100%",
                            background:
                              "linear-gradient(135deg, #0a3d62, #20c997)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: 56,
                            fontWeight: 900,
                            color: "#fff",
                            fontFamily: "'Playfair Display', Georgia, serif",
                            letterSpacing: "-2px",
                          }}
                        >
                          {getInitials(member.name)}
                        </div>
                      )}
                      {/* subtle overlay on hover */}
                      <div
                        className="team-img-overlay"
                        style={{
                          position: "absolute",
                          inset: 0,
                          background:
                            "linear-gradient(to top, rgba(10,22,40,0.3) 0%, transparent 60%)",
                          opacity: 0,
                          transition: "opacity 0.3s",
                        }}
                      />
                    </div>

                    {/* Info area */}
                    <div style={{ padding: "20px 24px 24px" }}>
                      <div
                        style={{
                          fontSize: 17,
                          fontWeight: 700,
                          color: "#0a1628",
                          marginBottom: 4,
                          fontFamily: "'Playfair Display', Georgia, serif",
                        }}
                      >
                        {member.name}
                      </div>
                      <div
                        style={{
                          fontSize: 13,
                          color: "#20c997",
                          fontWeight: 600,
                          marginBottom: member.department ? 10 : 0,
                        }}
                      >
                        {member.role}
                      </div>
                      {member.department && (
                        <span
                          style={{
                            display: "inline-block",
                            padding: "3px 12px",
                            borderRadius: 100,
                            background: "rgba(10,61,98,0.06)",
                            color: "#0a3d62",
                            fontSize: 11,
                            fontWeight: 600,
                          }}
                        >
                          {member.department}
                        </span>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        {/* ── VALUES ── */}
        {values.length > 0 && (
          <div style={S.valuesSection}>
            <div style={S.valuesInner}>
              <div style={S.label}>
                <span style={S.labelDot} />
                Core Principles
              </div>
              <h2 style={S.valuesHeading}>What Drives Us</h2>
              <div style={S.divider} />
              <div style={{ height: 8 }} />
              <p style={{ ...S.valuesSub, marginTop: 16 }}>
                Six core principles guide every decision, every protocol, and
                every patient interaction at Accelia.
              </p>
              <div style={S.valuesGrid}>
                {values.map((item, i) => (
                  <div
                    key={i}
                    style={{
                      ...S.valueCard,
                      transform:
                        hovered === `val-${i}` ? "translateY(-4px)" : "none",
                      boxShadow:
                        hovered === `val-${i}`
                          ? "0 12px 40px rgba(10,22,40,0.10)"
                          : S.valueCard.boxShadow,
                      borderColor:
                        hovered === `val-${i}` ? "#20c997" : "#e8edf4",
                    }}
                    onMouseEnter={() => setHovered(`val-${i}`)}
                    onMouseLeave={() => setHovered(null)}
                  >
                    <div style={S.valueIcon}>{item.icon}</div>
                    <div style={S.valueTitle}>{item.title}</div>
                    <p style={S.valueDesc}>{item.desc}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

        {/* ── CTA ── */}
        <div style={S.cta}>
          <div
            style={{
              position: "absolute",
              top: -100,
              right: -100,
              width: 400,
              height: 400,
              borderRadius: "50%",
              background:
                "radial-gradient(circle, rgba(32,201,151,0.08) 0%, transparent 70%)",
              pointerEvents: "none",
            }}
          />
          <div style={S.ctaInner}>
            <div
              style={{
                ...S.label,
                background: "rgba(32,201,151,0.15)",
                color: "#20c997",
                border: "1px solid rgba(32,201,151,0.3)",
                marginBottom: 24,
                display: "inline-flex",
              }}
            >
              <span style={S.labelDot} />
              Work With Us
            </div>
            <h2 style={S.ctaHeading}>Ready to Partner With Accelia?</h2>
            <p style={S.ctaSub}>
              Join our growing network of sponsors, CROs, and investigator sites
              driving clinical excellence across India.
            </p>
            <div style={S.ctaBtns}>
              <button
                style={S.btnPrimary}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-2px)";
                  e.currentTarget.style.boxShadow =
                    "0 10px 30px rgba(32,201,151,0.45)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "none";
                  e.currentTarget.style.boxShadow =
                    "0 6px 24px rgba(32,201,151,0.35)";
                }}
                onClick={() => {
                  navigate("/contact");
                  window.scrollTo(0, 0);
                }}
              >
                Contact Us →
              </button>
              <button
                style={S.btnOutline}
                onMouseEnter={(e) => {
                  e.currentTarget.style.borderColor = "rgba(255,255,255,0.7)";
                  e.currentTarget.style.background = "rgba(255,255,255,0.08)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.borderColor = "rgba(255,255,255,0.3)";
                  e.currentTarget.style.background = "transparent";
                }}
                onClick={() => {
                  navigate("/careers");
                  window.scrollTo(0, 0);
                }}
              >
                Join Our Team
              </button>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </>
  );
}
